export default{
    shopCart:{
        Notification:{
           
        },
        Message:{
            stoke:'商品库存数量不足！',
            delete:{
                invalid :'是否确认清空无效商品？',
                item:'是否确认删除此商品？',
                check:'是否确认删除选中商品？',
                noData:'请至少选择一个商品！',
                confirmTitle:'操作提示',
                confirmButtonText:'确定',
                cancelButtonText:'取消',
                success:'删除成功！',
            },
            orderTip:'暂不支持多店铺商品同时提单'
        },
        Alert:{
            error:{
                title:'提示',
                text:'数据请求失败，请重试',
                buttonText:'确定',
            }
        },
        Button:{
            noData:'继续逛逛',
            order:'确认下单',
        },
        Placeholder:{

        },
        Validate:{

        },
        Description:{
            msg:'注：因目前商城支付环节涉及多店铺支付方式及收货方式等原因，暂不支持多店铺一起提单，敬请谅解！',
            noData:'购物车内暂时没有商品哦~'
        },
        Checkbox:{
            all:'全选',
            delete:'删除选中商品',
            text1:'已选择',
            text2:'件商品',
            text3:'商品总金额',
        },
        Table:{
            headerName:['产品信息','数量','单价','单价小计','操作'],
        },
        ValidData:{
            item:{
                text:'库存',
                text1:'¥面议'
            }
        },
        InvalidData:{
            title:'无效商品',
            delete:'清空无效商品',
            item:{
                text1:'无效',
                text2:'商品已下架/库存不足',
            }
        }
    }
    
}